/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    BridgeApiTemplate,
    BridgeApiTemplateFromJSON,
    BridgeApiTemplateToJSON,
    BridgeTemplatesPage,
    BridgeTemplatesPageFromJSON,
    BridgeTemplatesPageToJSON,
} from '../models';

export interface FindTemplateByHandleRequest {
    id: string;
    stateAt?: Date;
}

export interface GetTemplatesByCategoryIdRequest {
    page: number;
    size: number;
    categoryId: string;
    recipientOrganisationId?: string;
}

/**
 * 
 */
export class BridgeTemplateApi extends runtime.BaseAPI {

    /**
     * Get template
     */
    async findTemplateByHandleRaw(requestParameters: FindTemplateByHandleRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeApiTemplate>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling findTemplateByHandle.');
        }

        const queryParameters: any = {};

        if (requestParameters.stateAt !== undefined) {
            queryParameters['stateAt'] = (requestParameters.stateAt as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeApiTemplateFromJSON(jsonValue));
    }

    /**
     * Get template
     */
    async findTemplateByHandle(requestParameters: FindTemplateByHandleRequest, initOverrides?: RequestInit): Promise<BridgeApiTemplate> {
        const response = await this.findTemplateByHandleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all templates for category
     */
    async getTemplatesByCategoryIdRaw(requestParameters: GetTemplatesByCategoryIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<BridgeTemplatesPage>> {
        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling getTemplatesByCategoryId.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling getTemplatesByCategoryId.');
        }

        if (requestParameters.categoryId === null || requestParameters.categoryId === undefined) {
            throw new runtime.RequiredError('categoryId','Required parameter requestParameters.categoryId was null or undefined when calling getTemplatesByCategoryId.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.categoryId !== undefined) {
            queryParameters['categoryId'] = requestParameters.categoryId;
        }

        if (requestParameters.recipientOrganisationId !== undefined) {
            queryParameters['recipientOrganisationId'] = requestParameters.recipientOrganisationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v3/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BridgeTemplatesPageFromJSON(jsonValue));
    }

    /**
     * Get all templates for category
     */
    async getTemplatesByCategoryId(requestParameters: GetTemplatesByCategoryIdRequest, initOverrides?: RequestInit): Promise<BridgeTemplatesPage> {
        const response = await this.getTemplatesByCategoryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
